<template>
    <div v-if="isNavLockActive">
        <MdTooltip
            v-bind="verifyEmailTooltipProps"
            class="fou-sidenav__item parentNav" :class="parentClass"
        >
            <div slot="trigger" class="fou-sidenav__item__link disabled" style="cursor: pointer;" @click="toggleDisabledAccordion" :id="dataId($t(sideNavTab.title),'tab')" :data-qa-id="dataId($t(sideNavTab.title), 'tab')">
                <span class="iconname-span">
                    <generalIcon className="icon" :iconFill="iconFillColor" :iconStroke="iconStrokeColor" :icon="sideNavTab.icon" />
                    <span class="iconname-span">{{ $t(sideNavTab.title) }}</span>
                </span>
                <arrow-icon v-if="showArrow" :class="['arrowIcon', disabledAccordionOpen ? 'rotateArrowIcon' : '']" :data-qa-id="dataId($t(sideNavTab.title),'arrow-icon')" />
            </div>
            <span slot="content" class="fou-tooltip__content">
                {{ $t(navLockTooltipKey) }}
            </span>
        </MdTooltip>
        <transition-slide>
            <ul
                v-if="showChildNavList"
                class="fou-sidenav__item fou-sidenav__item--innerwrap"
                :id="dataId($t(sideNavTab.title), 'parent')"
                :data-qa-id="dataId($t(sideNavTab.title), 'parent')"
            >
                <template v-for="nestRoute in visibleChildRoutes" :key="$t(nestRoute.title)">
                    <MdTooltip
                        v-bind="verifyEmailTooltipProps"
                        class="fou-sidenav__item parentNav" :class="parentClass"
                    >
                        <li
                            slot="trigger"
                            :class="getChildItemClass(nestRoute)"
                            :id="dataId($t(nestRoute.title), 'child')"
                            :data-qa-id="dataId($t(nestRoute.title), 'child')"
                        >
                            <span class="iconname-span"> {{ $t(nestRoute.title) }}</span>
                        </li>
                        <span slot="content" class="fou-tooltip__content">
                            {{ $t(navLockTooltipKey) }}
                        </span>
                    </MdTooltip>
                </template>
            </ul>
        </transition-slide>
    </div>
    <div v-else class="fou-sidenav__item parentNav" :class="parentClass">
        <div @click="changeRoute(sideNavTab, true, sideNavTab.title)" class="fou-sidenav__item__link" :id="dataId($t(sideNavTab.title),'tab')"
        :data-qa-id="dataId($t(sideNavTab.title), 'tab')">
            <span class="iconname-span">
                <MdIconSubmissions class="icon-submission-review" v-if="($t(sideNavTab.title) === 'Dashboard' && hasRole(['foundrySupport']))" icontitle="disabled" :color="isActive() ? 'blue-duck--500' : 'spirits--700'" size="sm" />
                <generalIcon v-else className="icon" :iconFill="iconFillColor" :iconStroke="iconStrokeColor"
                    :icon="sideNavTab.icon"></generalIcon>
                <span class="iconname-span">{{ ($t(sideNavTab.title) === 'Dashboard' && hasRole(['foundrySupport'])) ? $t('components.general.fou_side_navigation.submission_reviews') : $t(sideNavTab.title) }}</span>
            </span>
            <arrow-icon v-if="showArrow" class="arrowIcon" :class="isChildSelected ? 'rotateArrowIcon' : ''" :data-qa-id="dataId($t(sideNavTab.title), 'arrow-icon')" />
        </div>

    <transition-slide>
        <ul
            v-if="showChildNavList"
            class="fou-sidenav__item fou-sidenav__item--innerwrap"
            :id="dataId($t(sideNavTab.title), 'parent')"
            :data-qa-id="dataId($t(sideNavTab.title), 'parent')"
        >
            <template v-for="nestRoute in visibleChildRoutes" :key="$t(nestRoute.title)">
                <li
                    @click="onChildSelect(nestRoute)"
                    :class="getChildItemClass(nestRoute)"
                    :id="dataId($t(nestRoute.title), 'child')"
                    :data-qa-id="dataId($t(nestRoute.title), 'child')"
                >
                    <span class="iconname-span"> {{ $t(nestRoute.title) }}</span>
                </li>
            </template>
        </ul>
    </transition-slide>
    </div>
</template>
